///<reference path="../../definitions/weather.d.ts"/>
///<reference path="../util/SDTDate.ts"/>
///<reference path="../Const.ts"/>

namespace app.model{
	import SDTDate = app.util.SDTDate;
	export class Warn{
		data:WarnData;

		public parseData(data:WarnJSON){

			let	date:SDTDate = new SDTDate(data.atime, Const.DATE_WARN),
				areas:WarnArea[] = [];
			data.order.forEach((elm:string) => {
				let areaJSON = data.saibun[elm],
					areaData:WarnArea = {
						name:areaJSON.name,
						places:[]
					};
				areas.push(areaData);

				areaJSON.shchsn_list.forEach((elm) => {
					let placeJSON:PlaceJson = areaJSON[elm],
						placeData:WarnPlace = {
							name:placeJSON.name,
							warn:placeJSON.warn.concat()
						};
					areaData.places.push(placeData);
				});
			});
			this.data = {
				date:date,
				area:areas
			}
		}
	}

	 export let warn_list:{code:string, name:string, type:number}[] = [{
		code: "02",
		name: "暴風雪",
		type: 2
	}, {
		code: "03",
		name: "大雨",
		type: 2
	}, {
		code: "04",
		name: "洪水",
		type: 2
	}, {
		code: "05",
		name: "暴風",
		type: 2
	}, {
		code: "06",
		name: "大雪",
		type: 2
	}, {
		code: "07",
		name: "波浪",
		type: 2
	}, {
		code: "08",
		name: "高潮",
		type: 2
	}, {
		code: "10",
		name: "大雨",
		type: 1
	}, {
		code: "12",
		name: "大雪",
		type: 1
	}, {
		code: "13",
		name: "風雪",
		type: 1
	}, {
		code: "14",
		name: "雷",
		type: 1
	}, {
		code: "15",
		name: "強風",
		type: 1
	}, {
		code: "16",
		name: "波浪",
		type: 1
	}, {
		code: "17",
		name: "融雪",
		type: 1
	}, {
		code: "18",
		name: "洪水",
		type: 1
	}, {
		code: "19",
		name: "高潮",
		type: 1
	}, {
		code: "20",
		name: "濃霧",
		type: 1
	}, {
		code: "21",
		name: "乾燥",
		type: 1
	}, {
		code: "22",
		name: "なだれ",
		type: 1
	}, {
		code: "23",
		name: "低温",
		type: 1
	}, {
		code: "24",
		name: "霜",
		type: 1
	}, {
		code: "25",
		name: "着氷",
		type: 1
	}, {
		code: "26",
		name: "着雪",
		type: 1
	}, {
		code: "27",
		name: "その他",
		type: 1
	}, {
		code: "32",
		name: "暴風雪",
		type: 3
	}, {
		code: "33",
		name: "大雨",
		type: 3
	}, {
		code: "35",
		name: "暴風",
		type: 3
	}, {
		code: "36",
		name: "大雪",
		type: 3
	}, {
		code: "37",
		name: "波浪",
		type: 3
	}, {
		code: "38",
		name: "高潮",
		type: 3
	}];
}